// extracted by mini-css-extract-plugin
export var overlay = "Overlay-module--overlay--2CG5a";
export var transition = "Overlay-module--transition--1JMca";
export var display = "Overlay-module--display--qnDfQ";
export var backdrop = "Overlay-module--backdrop--1iNUt";
export var close = "Overlay-module--close--3c3oZ";